import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SignOut } from "@phosphor-icons/react";

const LOGO = "/ai-logo.jpg";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onLanding = pathname === "/";

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b border-zinc-800 bg-black/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <img src={LOGO} alt="AI iD Card" className="h-10 w-auto object-contain logo-neon" />
          <span className="font-mono-p font-bold tracking-tight text-lg text-zinc-100">
            AI <span className="text-cyan-400">iD</span> Card
          </span>
        </Link>

        <nav className="flex items-center gap-3">
          {user && user.role ? (
            <>
              <Link
                to="/dashboard"
                data-testid="nav-dashboard"
                className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
              >
                Dashboard
              </Link>
              <Link
                to="/warroom"
                data-testid="nav-warroom"
                className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
              >
                S.I.M.O.N.
              </Link>
              <Link
                to="/store"
                data-testid="nav-store"
                className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
              >
                Store
              </Link>
              <Link
                to="/plan"
                data-testid="nav-plan"
                className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
              >
                Plan
              </Link>
              <Link
                to="/activate"
                data-testid="nav-activate"
                className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
              >
                Activate
              </Link>
              {(user.role === "admin" || user.role === "support" || user.super_admin) && (
                <Link
                  to="/admin"
                  data-testid="nav-admin"
                  className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
                >
                  {user.role === "support" ? "Users" : "Admin"}
                </Link>
              )}
              <Link
                to="/support"
                data-testid="nav-support"
                className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
              >
                Support
              </Link>
              {(user.role === "admin" || user.role === "support" || user.super_admin) && (
                <Link
                  to="/support/admin"
                  data-testid="nav-support-desk"
                  className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
                >
                  Support Desk
                </Link>
              )}
              <button
                data-testid="nav-logout"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="flex items-center gap-2 font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-red-400 transition-colors px-3 py-2 border border-zinc-800 hover:border-red-400/40"
              >
                <SignOut size={14} /> Exit
              </button>
            </>
          ) : (
            onLanding && (
              <>
                <Link
                  to="/store"
                  data-testid="nav-store"
                  className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
                >
                  Pricing
                </Link>
                <Link
                  to="/support"
                  data-testid="nav-support-public"
                  className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
                >
                  Support
                </Link>
                <Link
                  to="/login"
                  data-testid="nav-login"
                  className="font-mono-p text-xs uppercase tracking-widest text-zinc-400 hover:text-cyan-400 transition-colors px-3 py-2"
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  data-testid="nav-register"
                  className="font-mono-p text-xs uppercase tracking-widest bg-cyan-400 text-black px-4 py-2 hover:bg-cyan-300 transition-colors font-bold"
                >
                  Sign Up Free
                </Link>
              </>
            )
          )}
        </nav>
      </div>
    </header>
  );
}
